import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, CalendarDays } from "lucide-react";
import api from "../../lib/api";
import { useSite } from "../../contexts/SiteContext";
import { fmtMoney } from "../../lib/sports";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default function AcademyPrograms({ academyId }) {
  const { L, sportLabel } = useSite();
  const [list, setList] = useState([]);
  useEffect(() => { api.get(`/public/academies/${academyId}/programs`).then(({ data }) => setList(data)).catch(() => {}); }, [academyId]);
  if (!list.length) return null;
  return (
    <section className="space-y-3" data-testid="academy-programs">
      <h2 className="font-oswald uppercase text-3xl">{L("Programs & classes", "Програми и тренировки")}</h2>
      <div className="grid md:grid-cols-2 gap-3">
        {list.map((p) => (
          <div key={p.id} className="rounded-2xl border border-white/10 bg-[#111D33] p-5" data-testid={`public-program-${p.id}`}>
            <p className="font-oswald text-2xl uppercase">{p.name}</p>
            <p className="text-sm text-white/60 inline-flex items-center gap-2"><CalendarDays className="w-4 h-4" /> {sportLabel(p.sport)} · {p.weekdays.map((d) => DAYS[d]).join("/")} {String(p.hour).padStart(2, "0")}:{String(p.minute).padStart(2, "0")} UTC · {p.duration_min} min</p>
            {p.description && <p className="text-sm text-white/70 mt-2">{p.description}</p>}
            <div className="mt-4 flex items-center justify-between">
              <span className="text-sm"><b>{fmtMoney(p.price, p.currency)}</b> / {L("person", "човек")} · <Users className="w-3.5 h-3.5 inline" /> {p.capacity}</span>
              <Link to={`/book/${academyId}?program=${p.id}`} className="btn-primary px-4 py-2 text-sm" data-testid={`book-program-${p.id}`}>{L("Book", "Резервирай")}</Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
